import React from 'react'
import GenericPopUp from 'Components/GenericPopUp'
import SystemPopUp from 'Components/SystemPopUp'
import OperationActionsModal from 'Components/OperationActionsModal'
import ExportPopUp from 'Components/ExportPopUp'
import OperationDetailModal from 'Components/OperationDetailModal'
import ProcessingRulesPopup from 'Components/ProcessingRulesPopup'
import EditTerminalPopup from 'Route/TerminalsManagement/components/EditTerminalPopup'
import SendDirectlyPopup from 'Components/SendDirectlyPopup'
import ManageUserPopUp from 'Route/Users/components/routeComponents/ManageUserModal'
import ManageVasPopUp from 'Route/TerminalsManagement/components/routeComponents/ManageVasPopup'
import ResultPopUp from 'Components/ResultPopUp'
import BookingDetailActionsPopUp from 'Route/BookingManagement/components/BookingDetail/subRouteComponents/BookingDetailActionsPopUp'
import ManageApiKeyModal from 'Route/TerminalsManagement/components/routeComponents/ManageApiKeyModal'
import ApmConfigurationModal from 'Components/ApmConfigurationModal'
import ManageStructurePopup from 'Route/TerminalsManagement/components/ManageStructurePopup'
import TermsAndConditionsDetailPopup from 'Route/TerminalsManagement/components/TermsAndConditionsDetailPopup'
import DisableVasPopup from 'Route/TerminalsManagement/components/DisableVasPopup'
import QrCodePopup from 'Components/QrCodePopup'
import TermsAndConditionsDisputlessPopup from 'Components/TermsAndConditionsDisputlessPopup'
import PblManagementActionsModal from 'Route/PblManagement/components/routeComponents/PblManagementActionsModal'
import PosGenericPopUp from 'Components/PosGenericPopUp'
import PayToCardPopup from 'Components/PayToCardPopup'

export const flowPopupMapType = {
  GENERIC_POPUP: 'GENERIC_POPUP',
  EXTEND_SESSION: 'EXTEND_SESSION',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  GENERIC_ERROR: 'GENERIC_ERROR',
  OPERATION_ACTION_POPUP: 'OPERATION_ACTION_POPUP',
  EXPORT_POPUP: 'EXPORT_POPUP',
  OPERATION_DETAIL_POPUP: 'OPERATION_DETAIL_POPUP',
  PROCESSING_RULES_POPUP: 'PROCESSING_RULES_POPUP',
  EDIT_TERMINAL_POPUP: 'EDIT_TERMINAL_POPUP',
  SEND_DIRECTLY_POPUP: 'SEND_DIRECTLY_POPUP',
  MANAGE_USER_POPUP: 'MANAGE_USER_POPUP',
  MANAGE_VAS_POPUP: 'MANAGE_VAS_POPUP',
  PAY_TO_CARD_POPUP: 'PAY_TO_CARD_POPUP',
  RESULT_POPUP: 'RESULT_POPUP',
  BOOKING_DETAIL_ACTIONS_POPUP: 'BOOKING_DETAIL_ACTIONS_POPUP',
  MANAGE_API_KEY_POPUP: 'MANAGE_API_KEY_POPUP',
  APM_CONFIGURATION: 'APM_CONFIGURATION',
  MANAGE_STRUCTURE_POPUP: 'MANAGE_STRUCTURE_POPUP',
  TERMS_AND_CONDITIONS_DETAIL_POPUP: 'TERMS_AND_CONDITIONS_DETAIL_POPUP',
  DISABLE_POS_TOKENIZATION_POPUP: 'DISABLE_POS_TOKENIZATION_POPUP',
  DISABLE_CLICK_N_COLLECT_POPUP: 'DISABLE_CLICK_N_COLLECT_POPUP',
  DISABLE_VAS_POPUP: 'DISABLE_VAS_POPUP',
  TERMS_AND_CONDITIONS_DISPUTLESS_POPUP: 'TERMS_AND_CONDITIONS_DISPUTLESS_POPUP',
  PBL_MANAGEMENT_ACTION_POPUP: 'PBL_MANAGEMENT_ACTION_POPUP',
  QR_CODE_POPUP: 'QR_CODE_POPUP',
  POS_GENERIC_POPUP: 'POS_GENERIC_POPUP'
}

export const flowPopupMap = {
  [flowPopupMapType.GENERIC_POPUP]: <GenericPopUp />,
  [flowPopupMapType.EXTEND_SESSION]: <SystemPopUp type='extend' />,
  [flowPopupMapType.SESSION_EXPIRED]: <SystemPopUp type='expired' />,
  [flowPopupMapType.GENERIC_ERROR]: <SystemPopUp type='error' />,
  [flowPopupMapType.OPERATION_ACTION_POPUP]: <OperationActionsModal />,
  [flowPopupMapType.EXPORT_POPUP]: <ExportPopUp />,
  [flowPopupMapType.OPERATION_DETAIL_POPUP]: <OperationDetailModal />,
  [flowPopupMapType.PROCESSING_RULES_POPUP]: <ProcessingRulesPopup />,
  [flowPopupMapType.EDIT_TERMINAL_POPUP]: <EditTerminalPopup />,
  [flowPopupMapType.SEND_DIRECTLY_POPUP]: <SendDirectlyPopup />,
  [flowPopupMapType.MANAGE_USER_POPUP]: <ManageUserPopUp />,
  [flowPopupMapType.MANAGE_VAS_POPUP]: <ManageVasPopUp />,
  [flowPopupMapType.PAY_TO_CARD_POPUP]: <PayToCardPopup />,
  [flowPopupMapType.RESULT_POPUP]: <ResultPopUp />,
  [flowPopupMapType.BOOKING_DETAIL_ACTIONS_POPUP]: <BookingDetailActionsPopUp />,
  [flowPopupMapType.MANAGE_API_KEY_POPUP]: <ManageApiKeyModal />,
  [flowPopupMapType.APM_CONFIGURATION]: <ApmConfigurationModal />,
  [flowPopupMapType.MANAGE_STRUCTURE_POPUP]: <ManageStructurePopup />,
  [flowPopupMapType.TERMS_AND_CONDITIONS_DETAIL_POPUP]: <TermsAndConditionsDetailPopup />,
  [flowPopupMapType.DISABLE_VAS_POPUP]: <DisableVasPopup />,
  [flowPopupMapType.TERMS_AND_CONDITIONS_DISPUTLESS_POPUP]: <TermsAndConditionsDisputlessPopup />,
  [flowPopupMapType.PBL_MANAGEMENT_ACTION_POPUP]: <PblManagementActionsModal />,
  [flowPopupMapType.QR_CODE_POPUP]: <QrCodePopup />,
  [flowPopupMapType.POS_GENERIC_POPUP]: <PosGenericPopUp />

}

export const getPopupByID = (id) => flowPopupMap[id]

export default flowPopupMap
